import { Card, Col, Container, Image, Row, Button, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { serverConfig } from '../../../services/server-config';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';
import axios from 'axios';
import { useUser } from '../userContext/userContext';
import {
  faPen,
  faSave,
  faEdit,
  faTrash,
  faCircleCheck,
  faBuilding,
  faFileAlt,
  faEnvelope,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import companyIcon from '../../../assets/images/client-profile-company.png';
import gstIcon from '../../../assets/images/client-profile-gst.png';
import emailIcon from '../../../assets/images/client-profile-email.png';
import locationIcon from '../../../assets/images/client-profile-location.png';
import pdfIcon from '../../../assets/images/Ic_Pdf.png';
import deleteIcon from '../../../assets/images/Ic_close.png';
import { useEffect, useState, useRef } from 'react';
import './clientUserProfile.css';
import ClientUserService from '../../../services/client-services/clientUserService';
import { decodeJWT } from '../../../services/candidateService';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
export const ClientUserProfile = () => {

  const [editState, setEditState] = useState({ emailId: false, phoneNumber: false });
  const [emailId, setEmailId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const { user: loggedInUser } = useUser();
  const [profileUser, setProfileUser] = useState(null);
  const location = useLocation();
  const passedUsername = location.state?.username;

  const decoded = decodeJWT(window.localStorage.getItem("authToken"));
  const loggedInUsername = _.get(decoded, "username", "");

  const username = passedUsername || loggedInUsername;

  useEffect(() => {

    if (!username) {
      console.error("Debug: No username provided!");
      setLoading(false);
      return;
    }
    setLoading(true);

    ClientUserService.getClientDetails(username)
      .then((response) => {
        if (!response.data || !response.data.users || response.data.users.length === 0) {
          console.warn("Debug: No user data found in API response!");
          return;
        }
        const userData = response.data?.users[0];
        if (userData) {
          setProfileUser(userData);

          setEmailId(userData.emailId);
          setPhoneNumber(userData.phoneNumber);

          if (userData.companyInfo) {
            setCompanyData({
              name: userData.companyInfo.companyName || "",
              gstin: userData.companyInfo.gstin || "",
              address: userData.companyInfo.address || "",
              district: userData.companyInfo.companyAddrPinCodeDetails?.district || "",
              state: userData.companyInfo.companyAddrPinCodeDetails?.state || "",
              pinCode: userData.companyInfo.companyAddrPinCodeDetails?.pinCode || "",
              email: userData.emailId || "",
            });
          }

          if (userData.docs && userData.docs.length > 0) {
          } else {
            console.warn("Debug: No documents found for user.");
          }

          const documents = userData.docs.map((doc) => ({
            name: doc.originalName,
            path: doc.path || "",
            size: `${doc.fileSize} ${doc.fileSizeUnit}`,
            status: "File uploaded successfully",
          }));
          setUploadedFiles(documents);

        }
      })
      .catch((error) => console.error("Error fetching user details:", error))
      .finally(() => setLoading(false));
  }, [username]);

  const saveUser = (field) => {
    setEditState({ ...editState, [field]: false });
  };

  // const handleOpenModal = () => setShowModal(true);
  // const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    setCompanyData({ ...companyData, [e.target.name]: e.target.value });
  };
  const handleEditClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not accessible.");
    }
  };


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const tempUrl = URL.createObjectURL(file);
      setProfileUser((prevUser) => ({ ...prevUser, imageBlobUrl: tempUrl }));

      const response = await ClientUserService.uploadProfilePicture(
        profileUser?.username || username,
        file
      );
      if (response.data.filePath) {

        setProfileUser((prevUser) => ({ ...prevUser, dpPath: response.data.filePath }));
        setTimeout(() => window.location.reload(), 500);
      }

    } catch (error) {
      console.error("Error uploading profile picture:", error);
    }
  };


  const handleDocFileChange = async (event) => {
    const validFormats = ["pdf", "doc", "docx"];
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const invalidFiles = files.filter((file) => {
      const ext = file.name.split(".").pop().toLowerCase();
      return !validFormats.includes(ext);
    });

    if (invalidFiles.length > 0) {
      setErrorMessage("Accepted File Formats: .pdf, .doc, .docx");
      return;
    }

    setErrorMessage("");

    const newFiles = files.map((file) => ({
      name: file.name,
      size: `${(file.size / 1024).toFixed(2)} KB`,
      status: "Pending Upload",
      file: file,
    }));

    setSelectedFiles(newFiles);
    await handleUpload(newFiles);
  };
  const handleUpload = async (filesToUpload) => {
    if (filesToUpload.length === 0) return;

    try {
      const uploadPromises = filesToUpload.map(async (fileObj) => {
        const response = await ClientUserService.uploadClientDocs(username, fileObj.file);
        const responseData = response?.data || response;
        if (!responseData) {
          throw new Error("No response data from server");
        }

        const users = responseData?.users ?? [];
        if (!users.length || !users[0].docs) {
          console.error("No docs array in response:", responseData);
          throw new Error("Response does not contain document paths.");
        }

        const uploadedDocs = users[0].docs;
        const uploadedFile = uploadedDocs.find(doc => doc.originalName === fileObj.name);

        if (!uploadedFile || !uploadedFile.path) {
          console.error("Uploaded file path missing:", uploadedDocs);
          throw new Error("No valid file path returned from server.");
        }

        return {
          name: fileObj.name,
          path: uploadedFile.path,
          size: fileObj.size,
          status: "File Uploaded Successfully",
        };
      });


      const results = await Promise.all(uploadPromises);
      setUploadedFiles((prev) => [...prev, ...results]);
      setSelectedFiles([]);

    } catch (error) {
      console.error("Error uploading documents:", error.message);
    }
  };
  const handleDownload = (filePath) => {
    ClientUserService.downloadFile(filePath)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const fileName = filePath.split("/").pop();
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("File download error:", error);
      });
  };

  const handleDeleteClick = (filePath) => {
    setFileToDelete(filePath);
    setShowConfirmModal(true);
  };

  const confirmDeleteFile = async () => {
    if (!fileToDelete) return;
    try {
      await ClientUserService.deleteClientFile(username, fileToDelete);
      setUploadedFiles((prevFiles) => prevFiles.filter((file) => file.path !== fileToDelete));
      setShowConfirmModal(false);
      setShowSuccessModal(true);
      setFileToDelete(null);
    } catch (error) {
      alert("Error deleting file: " + (error.response?.data || error.message));
    }
  };
  useEffect(() => {
    if (!profileUser?.dpPath) return;

    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${encodeURIComponent(profileUser.dpPath)}`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const url = URL.createObjectURL(blob);

        setProfileUser(prev => ({
          ...prev,
          imageBlobUrl: url,
        }));
      } catch (err) {
        console.error("Error loading profile pic:", err);
      }
    };

    fetchImage();
  }, [profileUser?.dpPath]);


  return (

    <div className="fluid-container">
      {loading && (
        <div className="mycandidates-loader-container">
          <div className="mycandidates-loader"></div>
        </div>
      )}
      {/* Breadcrumb */}
      <div className="profile-client-breadcrumb">
        <div
          className="breadcrumb-client"  >
          <Link
            to={-1}
            style={{ color: '#99A4AF', textDecoration: 'none' }}
            state={{ scrollPosition: sessionStorage.getItem("initialScrollPosition") }}
          >
            <img src={profilebackButtonIcon} alt="Back" className="profile-breadcrumb-back-icon" />{' '}
            <span className="profile-breadcrumb-back-text">Back</span>
          </Link>
        </div>
      </div>

      <Container className="client-user-profile-container">
        <Row className="client-profile-title-row">
          <Col>
            <h4 className="client-profile-heading">My Profile</h4>
          </Col>
        </Row>

        <Row className="client-profile-container">
          <Col md={3} className="client-profile-left">
            <div className="rounded-circle overflow-hidden position-relative client-profile-pic-container">
              <Image
                src={profileUser?.imageBlobUrl || default_profile_image}
                alt="Profile Image"
                onError={(e) => (e.target.src = default_profile_image)}
              />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileChange}
              />

              <div
                className="client-overlay d-flex align-items-center gap-2"
                onClick={handleEditClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter") handleEditClick(); }}
              >                <FontAwesomeIcon icon={faPen} color="#F35824" />
                <span>Edit Image</span>
              </div>
            </div>

            <div className="mt-3 client-profile-text">
              <h5 className="client-profile-username">{profileUser?.name}</h5>
              <p className="client-profile-role">{profileUser?.designation}</p>
              <p className="client-profile-userid">User ID: {profileUser?.username}</p>
            </div>
          </Col>

          <Col md={8} className="client-profile-right">
            {/* <Card className="client-personal-info-card mb-4">
              <h5 className="client-personal-info-heading">Personal Info</h5>
              <Row>
                <Col className="client-profile-info-section">
                  <p>Email ID : {emailId}</p>
                </Col>
                <Col className="client-profile-info-section">
                  <p>Mobile Number : {phoneNumber}</p>
                </Col>
              </Row>
            </Card> */}
            <Card className="client-personal-info-card mb-4">
              <h5 className="client-personal-info-heading">Personal Info</h5>
              <Row>
                <Col xs={12} md className="client-profile-info-section">
                  <div className="client-profile-info-label-container">
                    <p className="client-profile-info-label">
                      Email ID <FontAwesomeIcon icon={faCircleCheck} className="client-profile-verified-icon" />
                    </p>
                    {/* <FontAwesomeIcon
                      icon={faPen} color="#F35824"
                      className="client-profile-edit-icon"
                      onClick={() => setEditState({ ...editState, emailId: true })}
                    /> */}
                  </div>
                  {editState.emailId ? (
                    <Form.Control className="client-profile-form-control" value={emailId} onChange={(e) => setEmailId(e.target.value)} />
                  ) : (
                    <p className="client-profile-info-value">{emailId}</p>
                  )}
                  <div className="client-profile-horizontal-divider d-md-none"></div>

                </Col>

                <Col xs="auto" className="d-none d-md-flex align-items-center">
                  <div className="client-profile-vertical-divider"></div>
                </Col>

                <Col xs={12} md className="client-profile-info-section">
                  <div className="client-profile-info-label-container">
                    <p className="client-profile-info-label">
                      Mobile Number <FontAwesomeIcon icon={faCircleCheck} className="client-profile-verified-icon" />
                    </p>
                    {/* <FontAwesomeIcon
                      icon={faPen} color="#F35824"
                      className="client-profile-edit-icon"
                      onClick={() => setEditState({ ...editState, phoneNumber: true })}
                    /> */}
                  </div>
                  {editState.phoneNumber ? (
                    <Form.Control className="client-profile-form-control" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                  ) : (
                    <p className="client-profile-info-value">{phoneNumber}</p>
                  )}
                </Col>
              </Row>
            </Card>
            <Card className="client-company-info-card mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="client-company-info-heading">Company Info</h5>
                {/* <FontAwesomeIcon
                  icon={faPen}
                  className="client-profile-edit-icon"
                  color="#F35824"
                  onClick={handleOpenModal}
                  style={{ cursor: "pointer" }}
                /> */}
              </div>

              <Row className="mt-3">
                <Col md={6}>
                  <div className="client-profile-company-info-item">
                    <img src={companyIcon} alt="Company" className="client-profile-info-icon" />
                    <span>{companyData.name}</span>
                  </div>

                  <div className="client-profile-company-info-item">
                    <img src={gstIcon} alt="GSTIN" className="client-profile-info-icon" />
                    <span>{companyData.gstin}</span>
                  </div>

                  <div className="client-profile-company-info-item">
                    <img src={emailIcon} alt="Email" className="client-profile-info-icon" />
                    <span>{companyData.email}</span>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="client-profile-company-info-item">
                    <img src={locationIcon} alt="Location" className="client-profile-info-icon" />
                    <span>
                      {companyData.address}, {companyData.district}, {companyData.state} - {companyData.pinCode}
                    </span>
                  </div>
                </Col>
              </Row>

              {/* <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body>
                  <h4 className="text-center">Company Details</h4>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={companyData.name}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>GSTIN</Form.Label>
                      <Form.Control
                        type="text"
                        name="gstin"
                        value={companyData.gstin}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Business Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={companyData.address}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Business Email ID</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={companyData.email}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <button onClick={handleCloseModal}>Save</button>
                  </Form>
                </Modal.Body>
              </Modal> */}
            </Card>

            <Card className="client-documents-card">
              <h5 className="client-documents-heading">Documents</h5>
              <div className="client-document-upload-wrapper">
                <div className="client-document-upload-section mb-3">

                  <input
                    type="file"
                    id="documentUpload"
                    style={{ display: "none" }}
                    multiple
                    onChange={handleDocFileChange}
                  />

                  <button
                    className="client-profile-browse"
                    onClick={() => document.getElementById("documentUpload").click()}
                  >
                    Browse..
                  </button>
                  {/* <span className="ms-2">Or drop file here</span> */}
                </div>
                {errorMessage && (
                  <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                    {errorMessage}
                  </div>
                )}


                <div className="client-profile-uploaded-files mt-3">
                  {uploadedFiles.length > 0 ? (
                    uploadedFiles.map((file, index) => (
                      <div key={index} className="row align-items-start client-profile-file-row">
                        <div className="col-auto">
                          <img src={pdfIcon} alt="PDF Icon" className="client-profile-pdf-icon" />
                        </div>
                        <div className="col">
                          <strong
                            style={{ cursor: "pointer", color: "#2D3E50", textDecoration: "none" }}
                            onClick={() => handleDownload(file.path)}
                          >
                            {file.name}
                          </strong>
                          {/* <div>{file.size}</div> */}
                          <div></div>
                          <small style={{ color: '#3BB765' }}>{file.status}</small>
                        </div>
                        <div className="col-auto">
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            className="client-profile-trash-icon"
                            style={{ width: "20px", height: "20px", cursor: "pointer" }} // Adjust size as needed
                            onClick={() => handleDeleteClick(file.path)}
                          />
                        </div>
                        {/* <div className="col-auto client-profile-documents-icons">
                        {file.status === "File uploaded successfully" && (
                          <FontAwesomeIcon
                            icon={faPen}
                            className="client-profile-browse-edit-icon"
                            color="#F35824"
                          />
                        )}
                        {file.status !== "File uploaded successfully" && (
                          <div className="client-profile-close-icon">X</div>
                        )}
                      </div> */}
                      </div>
                    ))
                  ) : (
                    <p></p>
                  )}
                </div>

                <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                  <Modal.Header className="client-custom-modal-header">
                    <button className="register-popup-close" onClick={() => setShowConfirmModal(false)}>
                      <img src={deleteIcon} alt="Close" className="close-icon" />
                    </button>
                    <Modal.Title>Confirm Delete</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="client-custom-modal-body">
                    Are you sure you want to delete this file?
                  </Modal.Body>
                  <Modal.Footer className="client-custom-modal-footer">
                    <Button className="client-custom-cancel-btn" onClick={() => setShowConfirmModal(false)}>Cancel</Button>
                    <Button className="client-custom-delete-btn" onClick={confirmDeleteFile}>Delete</Button>
                  </Modal.Footer>
                </Modal>

                <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                  <Modal.Header>
                    <Modal.Title>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>File deleted successfully!</Modal.Body>
                  <Modal.Footer className="client-custom-modal-footer">
                    <Button className="client-custom-delete-btn" onClick={() => setShowSuccessModal(false)}>OK</Button>
                  </Modal.Footer>
                </Modal>
              </div>

            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};